export const BASE_URL = 'https://exchange-s.exodus.io/v3';
export const DEFAULT_SLIPPAGE = 2;
